module.exports = __webpack_public_path__ + "img/infrasel_4.ae1a7bf3.png";